import { useMemo } from 'react'
import { toMapsConfig, useAppLocale } from '@/locales/locale'

export const useMapsConfig = () => {
    const { language } = useAppLocale()

    return useMemo(() => toMapsConfig(language), [language])
}
